export interface IGetFhirCarePlanRequest {
  moduleName: string;
}
